import React from 'react';
import {InputControlMask} from './InputControlMask';
import { Tooltip } from './Tooltip';
const Input = ({
    id,
    type = 'text',
    field = '',
    label = '',
    value = '',
    placeholder = '',
    mask ='',
    pattern = '',
    isRequired = true,
    className = '',
    useTooltip = false,
    titleTooltip = '',
    textTooltip = '',
    onChange = () => ''

}) => {

    const control = {
        text: <input
            id={id}
            name={field}
            type={type}
            value={value}
            className="input-ca"
            placeholder={placeholder}
            onChange={onChange}
            required={isRequired}
            autoComplete='off'
        />,
        mask: <InputControlMask
            name={field}
            onChange={onChange}
            className='input-ca'
            type={type}
            id={id}
            placeholder={placeholder}
            value={value}
            mask={mask}
            required={isRequired}
            pattern={pattern}
            autoComplete='off'
        />,
        number: <input
        id={id}
        name={field}
        onChange={onChange}
        className='input-ca'
        type={type}
        placeholder={placeholder}
        value={value}
        required={isRequired}
        min={0}
    />,
    }

    return (
        <div className={className}>
              {!useTooltip &&
                <div className="lbl-input-ca lbl-input-ca-size">
                    <span> {label} </span>
                </div>

            }
            {useTooltip && <div className="lbl-input-ca lbl-input-ca-size">
                <span> {label} </span>
                <Tooltip title={titleTooltip} text={textTooltip} id={`${field}_tooltip`} />
            </div>
            }
            {
                control[type]
            }
        </div>
    );
}

export { Input }